// extracted by mini-css-extract-plugin
export var indeterminate = "_20-5";
export var md = "_20-4";
export var semantic = "_20-6";
export var sm = "_20-3";
export var text = "_20-7";
export var toggleInput = "_20-0";
export var toggleSwitch = "_20-1";
export var xs = "_20-2";